export const KEYS = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"]
  .flatMap((n) => [`${n} major`, `${n} minor`]);
export const DEFAULT_GENRES = ["Trap", "Drill", "Hip-Hop", "Boom Bap", "R&B", "Pop", "Afrobeat", "Reggaeton", "Lo-Fi", "Manele"];

const inputCls = "w-full mt-1 bg-[#121212] border border-white/10 focus:border-[#D90429] outline-none px-3 py-2.5 text-sm";
const labelCls = "text-xs text-[#A0A0A0] uppercase tracking-wider";

export const BeatMetaFields = ({ value, onChange, genres = [], prefix }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const allGenres = [...new Set([...DEFAULT_GENRES, ...genres])];
  return (
    <>
      <div>
        <label className={labelCls}>Tempo (BPM)</label>
        <input type="number" min={40} max={300} value={value.bpm} onChange={set("bpm")} placeholder="140"
          className={inputCls} data-testid={`${prefix}-bpm-input`} />
      </div>
      <div>
        <label className={labelCls}>Key</label>
        <select value={value.key} onChange={set("key")} className={inputCls} data-testid={`${prefix}-key-select`}>
          <option value="">—</option>
          {KEYS.map((k) => <option key={k} value={k}>{k}</option>)}
        </select>
      </div>
      <div>
        <label className={labelCls}>Genre</label>
        <input list={`${prefix}-genres`} value={value.genre} onChange={set("genre")} placeholder="Pick or type"
          className={inputCls} data-testid={`${prefix}-genre-input`} />
        <datalist id={`${prefix}-genres`}>{allGenres.map((g) => <option key={g} value={g} />)}</datalist>
      </div>
      <div className="col-span-full">
        <label className={labelCls}>Availability</label>
        <div className="mt-1 grid grid-cols-2 border border-white/10" data-testid={`${prefix}-sale-toggle`}>
          {[[true, "For sale"], [false, "Not for sale"]].map(([v, l]) => (
            <button key={l} type="button" onClick={() => onChange({ ...value, for_sale: v })} aria-pressed={value.for_sale === v}
              data-testid={`${prefix}-sale-${v ? "yes" : "no"}`}
              className={`py-2.5 text-xs font-bold uppercase tracking-wider transition-colors ${value.for_sale === v ? "bg-[#D90429] text-white" : "bg-[#121212] text-white/50 hover:text-white"}`}>
              {l}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export const appendMeta = (fd, meta) => {
  fd.append("bpm", meta.bpm ?? "");
  fd.append("key", meta.key ?? "");
  fd.append("genre", meta.genre ?? "");
  fd.append("for_sale", meta.for_sale === false ? "false" : "true");
};

export const EMPTY_META = { bpm: "", key: "", genre: "", for_sale: true };
